<section class="view-stats sf-section">
  <header class="view-stats__header">
    <div>
      <p class="view-stats__eyebrow">{{ 'creator.dashboard.views.eyebrow' | transloco }}</p>
      <h2 class="view-stats__title">{{ 'creator.dashboard.views.title' | transloco }}</h2>
      <p class="view-stats__description">{{ 'creator.dashboard.views.description' | transloco }}</p>
    </div>

    <div class="view-stats__cards">
      <div class="view-stats__card">
        <div class="view-stats__card-label">
          <span class="view-stats__card-label-text">{{ 'creator.dashboard.views.cards.search' | transloco }}</span>
          <app-info-tooltip
            textKey="creator.dashboard.views.cards.searchTooltip"
            ariaLabelKey="creator.dashboard.views.cards.searchTooltipLabel"
          ></app-info-tooltip>
        </div>
        @if (totalSearchViews !== null) {
          <p class="view-stats__card-value">{{ totalSearchViews }}</p>
        } @else {
          <div class="view-stats__card-value skeleton-loading"></div>
        }
      </div>
      <div class="view-stats__card">
        <div class="view-stats__card-label">
          <span class="view-stats__card-label-text">{{ 'creator.dashboard.views.cards.profile' | transloco }}</span>
          <app-info-tooltip
            textKey="creator.dashboard.views.cards.profileTooltip"
            ariaLabelKey="creator.dashboard.views.cards.profileTooltipLabel"
          ></app-info-tooltip>
        </div>
        @if (totalProfileViews !== null) {
          <p class="view-stats__card-value">{{ totalProfileViews }}</p>
        } @else {
          <div class="view-stats__card-value skeleton-loading"></div>
        }
      </div>
    </div>

    <div class="view-stats__controls">
      @if (timeframeControlOptions && timeframe) {
        <div class="view-stats__segmented-group"
             role="group"
             aria-label="{{ 'creator.dashboard.views.timeframe.label' | transloco }}"
        >
          <app-segmented-control
            class="view-stats__segmented"
            [options]="timeframeControlOptions"
            [value]="timeframe"
            (valueChange)="onTimeframeChange($event)"
          ></app-segmented-control>
        </div>
      }
      @if (metricControlOptions && metric) {
        <div class="view-stats__segmented-group"
             role="group"
             aria-label="{{ 'creator.dashboard.views.metric.label' | transloco }}"
        >
          <app-segmented-control
            class="view-stats__segmented"
            [options]="metricControlOptions"
            [value]="metric"
            (valueChange)="onMetricChange($event)"
          ></app-segmented-control>
        </div>
      }
    </div>
  </header>

  <div class="view-stats__chart" [class.view-stats__chart--plain]="isEmpty">
    @if (loading) {
      <p class="view-stats__state">{{ 'creator.dashboard.views.loading' | transloco }}</p>
    } @else if (error) {
      <p class="view-stats__state view-stats__state--error">{{ error }}</p>
    } @else if (hasData) {
      <apx-chart
        [series]="chartSeries"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [yaxis]="chartOptions.yaxis"
        [dataLabels]="chartOptions.dataLabels"
        [stroke]="chartOptions.stroke"
        [fill]="chartOptions.fill"
        [tooltip]="chartOptions.tooltip"
        [legend]="chartOptions.legend"
        [grid]="chartOptions.grid"
        [colors]="chartOptions.colors"
        [markers]="chartOptions.markers"
      ></apx-chart>
    } @else {
      <div class="view-stats__empty">
        <i class="fa-solid fa-chart-line view-stats__icon" aria-hidden="true"></i>
        <p class="view-stats__state-title">{{ 'creator.dashboard.views.empty.title' | transloco }}</p>
        <p class="view-stats__state">{{ 'creator.dashboard.views.empty.description' | transloco }}</p>
      </div>
    }
  </div>
</section>
